import React from 'react';
import OkModalOnboarding from '../../../../commons/OkModalOnboarding/OkModalOnboarding';
import { VideoScreenModalBody } from 'components/newIdentifyMethods/VideoScreen/VideoScreenDispatcher/VideoScreenModal/VideoScreenModalBody/VideoScreenModalBody';
import { LEAVE } from 'constants/video/status';

export const VideoScreenModal = props => {
    const { showModal, statusCode, leaveModalTag, handlePrevious, handleModal } = props;

    const leaveModalClose = () => {
        leaveModalTag('cerrar');
        handleModal(false);
    };

    const handleOnClose = () => {
        statusCode === LEAVE ? leaveModalClose() : handlePrevious();
    };

    return (
        <OkModalOnboarding
            onClose={handleOnClose}
            modalIsOpen={showModal}
            headerCloseIcon={false}
            className="video-screen__modal-content"
        >
            <VideoScreenModalBody {...props} />
        </OkModalOnboarding>
    );
};
